export default __webpack_public_path__ + "static/media/graph-lowest.942e44b0.png";